import React from "react";
import { classNames } from "primereact/utils";

export type DashlyLeadingIcon = string | ((value: unknown) => string | undefined);

export const resolveLeadingIconClass = (
    leadingIcon: DashlyLeadingIcon | undefined,
    value: unknown
): string | undefined => {
    if (!leadingIcon) {
        return undefined;
    }
    if (typeof leadingIcon === "function") {
        return leadingIcon(value);
    }
    return leadingIcon;
};

export const DashlyLeadingIconSlot: React.FC<{
    iconClass?: string;
    /** Absolute-position slot class, e.g. `dashly-text-input-wrap__leading-icon`. */
    className?: string;
}> = ({ iconClass, className }) => {
    if (!iconClass) {
        return null;
    }
    return <i className={classNames(className, iconClass)} aria-hidden />;
};
